'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { DismissButton } from '@react-aria/overlays';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { PopoverContentInternal } from './popover-content-internal.component.js';
import { PopoverDialog } from './popover-dialog.component.js';
import { useSwanPopover } from './popover.context.js';
import { renderWithRef } from '../core/render-with-ref.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const PopoverContent = renderWithRef('PopoverContent', null, (o, a)=>{
    var c;
    useDeprecatedProps('PopoverContent', o, [
        {
            propName: 'dialog',
            instructions: 'Popovers are always treated as dialogs now, so this prop is unnecessary.'
        },
        {
            propName: 'labelText',
            instructions: 'Use `aria-label` or `aria-labelledby` instead.'
        }
    ]);
    let { children: s, dialog: b, fullBleed: u, hideArrow: f, placement: d, 'aria-label': _, 'aria-labelledby': y } = o, j = _object_without_properties(o, [
        "children",
        "dialog",
        "fullBleed",
        "hideArrow",
        "placement",
        'aria-label',
        'aria-labelledby'
    ]), { overlayState: m, popoverPlacement: O, triggerProps: v } = useSwanPopover(), w = _object_spread_props(_object_spread({}, j), {
        hideArrow: f,
        placement: null !== (c = null != d ? d : O) && void 0 !== c ? c : 'top',
        fullBleed: null != u ? u : void 0
    }), g = {
        'aria-label': _,
        'aria-labelledby': _ ? void 0 : y || (null == v ? void 0 : v.id)
    };
    return m.isOpen ? jsx(PopoverContentInternal, _object_spread_props(_object_spread({}, w), {
        ref: a,
        children: jsxs(PopoverDialog, _object_spread_props(_object_spread({}, g), {
            children: [
                jsx(DismissButton, {
                    onDismiss: ()=>m.close
                }),
                s,
                jsx(DismissButton, {
                    onDismiss: ()=>m.close
                })
            ]
        }))
    })) : null;
});

export { PopoverContent };
